import { render, staticRenderFns } from "./ProjectFormCard.vue?vue&type=template&id=53d8bcc4&scoped=true&"
import script from "./ProjectFormCard.vue?vue&type=script&lang=ts&"
export * from "./ProjectFormCard.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectFormCard.vue?vue&type=style&index=0&id=53d8bcc4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d8bcc4",
  null
  
)

export default component.exports